// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__rWgHc","actions":"GroupTable_actions__1SaCt","deleteModalFooter":"GroupTable_deleteModalFooter__1g0Sg"};